import { z } from 'zod';
import { EvaluationSourceSchema, EvaluationSuiteConfigSchema, EvaluationSuiteTaskBatchSchema, } from './evaluation.js';
import { EvaluationSuiteEfficiencySchema } from './evaluationEfficiency.js';
import { EvaluationSuiteScoreSchema } from './evaluationScore.js';
export const EvaluationPublishedArtifactSchema = z.object({
    checksum: z.string().regex(/^[0-9a-f]{64}$/u),
    checksumAlgorithm: z.literal('sha256'),
    path: z.string(),
    sizeBytes: z.number().int().nonnegative(),
});
export const EvaluationPublicationManifestSchema = z.object({
    artifactPrefix: z.string(),
    artifacts: z.array(EvaluationPublishedArtifactSchema),
    completedAt: z.string(),
    config: EvaluationSuiteConfigSchema,
    efficiency: EvaluationSuiteEfficiencySchema.optional(),
    failureReason: z.string().optional(),
    schemaVersion: z.literal(1),
    score: EvaluationSuiteScoreSchema.optional(),
    source: EvaluationSourceSchema,
    startedAt: z.string(),
    status: z.enum(['failed', 'incomplete', 'passed']),
    suiteId: z.string(),
    taskBatches: z.array(EvaluationSuiteTaskBatchSchema),
});
//# sourceMappingURL=evaluationPublication.js.map